import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBasedQuery';

import { HTTP_METHODS, buildQueryString } from '../../utils/handler';
import { LEAVE_REQUEST } from '../../utils/constant/routeURL';
import { API_BASE_URL } from '../../config';

const { GET, POST, DELETE, PUT } = HTTP_METHODS;
const { LEAVE_REQUEST_GET, LEAVE_REQUEST_COUNT } = LEAVE_REQUEST;

export const leaveRequestApi = createApi({
  reducerPath: 'leaveRequestApi',

  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),

  endpoints: (builder) => ({
    getLeaveRequest: builder.query({
      query: (data) => ({ url: `${LEAVE_REQUEST_GET}${buildQueryString(data)}`, method: GET }),
      keepUnusedDataFor: 0
    }),
    getLeaveCount: builder.query({
      query: (data) => ({ url: `${LEAVE_REQUEST_COUNT}${buildQueryString(data || {})}`, method: GET }),
      keepUnusedDataFor: 0
    }),
    addLeaveRequest: builder.mutation({
      query: (data) => ({ url: LEAVE_REQUEST_GET, method: POST, data })
    }),
    deleteLeaveRequest: builder.mutation({
      query: (id) => ({
        url: `${LEAVE_REQUEST_GET}/${id}`,
        method: DELETE
      })
    }),
    editLeaveRequest: builder.mutation({
      query: (data) => ({
        url: `${LEAVE_REQUEST_GET}/${data?.id}`,
        method: PUT,
        data: data.data
      })
    })
  })
});

export const {
  useGetLeaveRequestQuery,
  useGetLeaveCountQuery,
  useAddLeaveRequestMutation,
  useEditLeaveRequestMutation,
  useDeleteLeaveRequestMutation
} = leaveRequestApi;
